import { Marker, DivIcon, divIcon } from 'leaflet'
import { CustomMarkerOptions } from '@/interfaces/MarkerOptions'
//import { MarkerIcons } from '@/interfaces/MarkerIcons'

interface MarkerData {
	id: string
	name: string
	docTypeAlias: string
	projectStatus: string
	excerpt: string
	projectImageUrl?: string
	url?: string
	label?: string
	visible: boolean
	arcgisProjectName: string
	projectStatusDisplayValue?: string
}

export function CustomMarker(
	coords: L.LatLngExpression,
	properties: any,
	markerData?: MarkerData
): Marker {
	const PARSELL =
		markerData?.name != null ? markerData.name : properties?.parsell
	let markerIcon =
		markerData?.projectStatus != null
			? markerData.projectStatus.toLowerCase()
			: 'planning'
	if (markerData?.docTypeAlias == 'mainProject') {
		markerIcon = 'nv-mainproject'
	}
	const customIcon: DivIcon = divIcon({
		className: 'custom-marker',
		html: `<div role="link" aria-label="${PARSELL}" class="icon-container ${markerData?.docTypeAlias} uk-position-absolute uk-flex uk-flex-middle uk-flex-center"><span class='uk-icon' uk-icon="${markerIcon}"></span></div>`,
		iconSize: [28, 28],
		iconAnchor: [15, 34],
		popupAnchor: [0, 6],
	})
	let displayStatus =
		markerData?.projectStatusDisplayValue != null
			? markerData.projectStatusDisplayValue
			: getDisplayStatus(markerData?.projectStatus)
	if (markerData?.docTypeAlias == 'mainProject') {
		//displayStatus = getDisplayStatus(markerData?.projectStatus)
		displayStatus = 'Hovedstrekning'
	}
	let parsellString = PARSELL.replace('-', ' - ')
	parsellString = parsellString.split(' ')
	parsellString[parsellString.length - 1] =
		'<span class="uk-text-nowrap">' +
		parsellString[parsellString.length - 1] +
		'&nbsp;<span class="uk-icon" uk-icon="icon: nv-arrow; ratio: .65"></span></span>'

	let content = `<a href="#" class="leaflet-popup-close-button"><span class="close-button" uk-icon="icon: nv-minus;"></span></a><span class='uk-icon' uk-icon="${markerIcon}"></span> ${displayStatus}`
	if (markerData?.url != null) {
		content += `<p><a class="uk-flex uk-flex-middle" href="${
			markerData.url
		}"><span>${parsellString.join(' ')}</a></p>`
	} else {
		content += `<p>${PARSELL}</p>`
	}
	/* Disabled for now
	if (image != null) {
		content += `<img src="${image}" alt="${PARSELL}" />`
	}*/
	const markerOptions: CustomMarkerOptions = {
		name: PARSELL,
		icon: customIcon,
		status: displayStatus,
		docType: markerData?.docTypeAlias,
		// ... other desired options like popupAnchor, etc.
	}

	const newMarker = new Marker(coords, markerOptions).bindPopup(
		'<div class="popup-inner">' + content + '</div>',
		{
			minWidth: 220,
			maxWidth: 220,
			className: `custom-popup ${markerData?.docTypeAlias}`,
		}
	)
	newMarker.on('mouseenter', function (e) {
		const element = (e.target as any).getElement()
		if (element == null) return
		element.classList.add('hover')
	})
	newMarker.on('mouseout', function (e) {
		const element = (e.target as any).getElement()
		if (element == null) return
		element.classList.remove('hover')
	})
	newMarker.on('popupopen', (e) => {
		// Hide icon when popup opens
		const popup = newMarker.getPopup()
		let closeButton = popup?.getElement()?.querySelector('.close-button')
		if (closeButton) {
			closeButton.addEventListener('click', function () {
				newMarker.closePopup()
			})
		}

		if (e.target) {
			const element = (e.target as any).getElement()
			if (element) {
				element.style.display = 'none'
			}
		}
	})

	newMarker.on('popupclose', (e) => {
		// Show icon when popup closes
		if (e.target) {
			const element = (e.target as any).getElement()
			if (element) {
				element.style.display = 'block'
			}
		}
	})
	return newMarker
}

function getDisplayStatus(status?: string): string {
	switch (status) {
		case 'Prioritert':
		case 'Forberedes':
			return 'Planlegges'
		case 'Building':
			return 'Bygger'
		case 'Kontrakt':
			return 'Bygger'
		case 'Åpnet':
			return 'Ferdig'
		default:
			return 'Planlegges'
	}
}
